export default __webpack_public_path__ + "static/media/2296.706abefe.png";